.textField {
  input {
    border-radius: inherit;

    &:disabled {
      cursor: not-allowed;
    }
  }

  &.error {
    box-shadow: inset 0 0 0 1px var(--red-9);
    border-color: var(--red-9);
    background-color: var(--red-1) !important;
    outline: var(--red-9) !important;

    input {
      &:active {
        color: var(--red-12);
      }
      &:focus {
        color: var(--red-12);
      }

      ::placeholder {
        color: var(--red-12);
        opacity: 1;
      }
      ::-webkit-input-placeholder {
        color: var(--red-12);
        opacity: 1;
      }
      ::-ms-input-placeholder {
        color: var(--red-12);
        opacity: 1;
      }
    }
  }
}
